(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rucapi-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const homes = document.querySelectorAll('[data-rucapi-home]');
    homes.forEach((home) => {
      const select = home.querySelector('[data-inventory-circuit]');
      const search = home.querySelector('[data-inventory-search]');
      const records = Array.from(home.querySelectorAll('[data-inventory-record]'));
      const normalize = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
      const filterInventory = () => {
        const query = normalize(search.value); let visible = 0;
        records.forEach(row => { const match = (select.value === 'all' || row.dataset.circuits.split(' ').includes(select.value)) && normalize(row.textContent).includes(query); row.hidden = !match; if (match) visible++; });
        home.querySelector('[data-inventory-empty]').hidden = visible > 0;
      };
      if (select && search) { select.addEventListener('change', filterInventory); search.addEventListener('input', filterInventory); }
      home.querySelectorAll('[data-circuit-link]').forEach(link => link.addEventListener('click', () => { select.value = link.dataset.circuitLink; search.value = ''; filterInventory(); home.querySelector('.rucapi-inventory').open = true; }));
      const buttons = home.querySelectorAll('[data-species-filter]');
      const groups = home.querySelectorAll('[data-species-group]');
      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const filter = button.dataset.speciesFilter;
          buttons.forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
      groups.forEach((group) => {
            group.hidden = filter !== 'all' && group.dataset.speciesGroup !== filter;
          });
        });
      });
      const hotspotButtons = home.querySelectorAll('[data-hotspot]');
      const hotspotNumber = home.querySelector('[data-hotspot-number]');
      const hotspotTag = home.querySelector('.rucapi-explorer__panel [data-hotspot-tag]');
      const hotspotTitle = home.querySelector('.rucapi-explorer__panel [data-hotspot-title]');
      const hotspotDescription = home.querySelector('.rucapi-explorer__panel [data-hotspot-description]');
      hotspotButtons.forEach((button) => {
        button.addEventListener('click', () => {
          hotspotButtons.forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
          if (hotspotNumber) hotspotNumber.textContent = button.dataset.hotspotIndex;
          if (hotspotTag) hotspotTag.textContent = button.dataset.hotspotTag;
          if (hotspotTitle) hotspotTitle.textContent = button.dataset.hotspotTitle;
          if (hotspotDescription) hotspotDescription.textContent = button.dataset.hotspotDescription;
          const link = home.querySelector('[data-hotspot-link]'); if (link) link.href = button.dataset.hotspotTarget;
        });
      });
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.12 });
        home.querySelectorAll('.rucapi-reveal').forEach((item) => observer.observe(item));
      } else {
        home.querySelectorAll('.rucapi-reveal').forEach((item) => item.classList.add('is-visible'));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rucapi-visits"] && !Shopify.designMode) return;
  try {
    
const selectedCircuit = new URLSearchParams(window.location.search).get('circuito');
if (selectedCircuit && /^C0[1-4]$/.test(selectedCircuit)) { const checkbox = document.querySelector('[data-visit-circuit="' + selectedCircuit + '"]'); if (checkbox) checkbox.checked = true; }

  } catch(e) { console.error(e); }
})();
})();
